import { Activity } from 'src/@types/activity';
import { BusinessCustomer } from '../customers/types.api';
import { ValueUnit } from 'src/@types/common';

//
//

export type PurchaseByIdQuery = {
  id: string;
  customerFullName?: boolean;
};

export type PurchaseReceiptQuery = {
  id: string;
}

export type PurchaseByIdResponse = Purchase;

export type Purchase = {
  id: string;
  netAmount: Price;
  paymentProviderFee: Price;
  serviceFee: Price;
  totalAmountCharged: Price;
  transactionDate: number;
  status: string;
  orderReference: string;
  type: PurchaseType;
  ownershipType: TransactionOwnershipType;
  activity: Activity;
  merchantCode: string;
  emailAddress?: string;
  programmeCode?: string;
  orderDescription?: string;
  businessCustomer?: BusinessCustomer;
  customerFullName: string;

  reference?: any;
  carbonOffsetQuantity?: ValueUnit;
  marketingOptIn?: false;
  paymentProvider?: string;
  paymentProviderReference?: string;
  description?: string;
};

export enum TransactionOwnershipType {
  MERCHANT = 'MERCHANT',
  CUSTOMER = 'CUSTOMER',
  PERSONAL = 'PERSONAL',
}

export enum PurchaseType {
  FIXED_COST_SUBSCRIPTION = 'FIXED_COST_SUBSCRIPTION',
  CLIMATE_FRIENDLY_CART = 'CLIMATE_FRIENDLY_CART',
  FIXED_OFFSET = 'FIXED_OFFSET',
  AASF_REWARDS = 'AASF_REWARDS',
  GROUP_SUBSCRIPTION = 'GROUP_SUBSCRIPTION',
  JOURNEY = 'JOURNEY',
  FLIGHT = 'FLIGHT',
  BUSINESS_FOOTPRINT = 'BUSINESS_FOOTPRINT',
  EMISSION_RECORD = 'EMISSION_RECORD',
  ACCOMMODATION = 'ACCOMMODATION',
}

export type Price = {
  currency: string;
  symbol?: string;
  value: number;
  zeroDecimalCurrency?: boolean;
};

//

export type StartPurchaseByQuoteData = {
  quoteId: string;
};

//

export type CreatePurchaseByQuoteQueryParams = {
  emailAddress: string;
  paymentIntentId?: string;
  paymentProvider: string;
  paymentProviderToken?: string | null;
  quoteId: string;
  disableNotifications: boolean;
  orderDescription?: string;
  paymentReference?: string;
  programmeCode?: string;
  businessCustomerId?: string;
  ownershipType: string;
};

//

export type CreateInvoiceQueryParams = {
  quoteId: string;
  merchantCode: string;
};

export type LinkBusinessCustomerPayload = {
  purchaseId: string;
  businessCustomerId: string;
}
